var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.isOpen,
            "show-close": true,
            title: "Tạo mã QR code",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "80%" },
                        attrs: {
                          size: "small",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          format: "dd-MM-yyyy",
                          placeholder: "Chọn ngày",
                          clearable: false,
                        },
                        model: {
                          value: _vm.dataInput.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "date", $$v)
                          },
                          expression: "dataInput.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            loading: _vm.isLoading.createQr,
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.createQrCodeForSupperPlusManual()
                            },
                          },
                        },
                        [_vm._v("\n            Tạo QR code\n          ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", { staticStyle: { "margin-bottom": "6px" } }, [
                        _vm._v("Cố định"),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.fixed,
                            callback: function ($$v) {
                              _vm.fixed = $$v
                            },
                            expression: "fixed",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                  [
                    _c("i", { staticClass: "el-icon-circle-close" }),
                    _vm._v("\n          Đóng\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }